// This file is auto generated using CMS based event tracking.
// Do not modify this file manually!
import { BaseTrackingContext } from '@goeuro/app/client/tracking-provider/src/cms/lib/BaseTrackingContext';

/* Properties block */
export type RefundPolicyContextProperties = {
  return_number_of_fare_terms?: number;
  return_display_price?: string;
  return_policy_type?: string;
  display_price: string;
  number_of_fare_terms?: number;
  policy_type?: string;
  number_of_policies?: number;
  return_number_of_policies?: number;
};

/* Context definition block */
const schema = 'iglu:com.goeuro/refund_policy_context/jsonschema/2-0-2';
export const refundPolicyContextName = 'refund_policy_context';
export class RefundPolicyContext extends BaseTrackingContext<RefundPolicyContextProperties> {
  constructor(properties: RefundPolicyContextProperties) {
    super(refundPolicyContextName, schema, properties);
  }
}
